export default __webpack_public_path__ + "static/vine-0422f17e0323f131b25c7333e73c8bfe.webp";